function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @param {Object[]} filters - Array of objects with properties defined in Datepicker/index.js
 * @returns {Object|null} - returns filter that contains 'selected: true' if found, else returns null
 */
export var getInitialSelectedFilter = function getInitialSelectedFilter(filters) {
  if (filters.length === 0) {
    return null;
  }

  var foundIdx;
  var preselected = filters.find(function (filter, idx) {
    if (filter.selected === true) {
      foundIdx = idx;
      return true;
    }

    return false;
  });
  if (!preselected) return null;
  return _objectSpread(_objectSpread({}, preselected), {}, {
    idx: foundIdx
  });
};
export default getInitialSelectedFilter;